module.exports = "<div class=\"loginTop\">\r\n    <span id=\"log\"></span>\r\n    <div class=\"loginContainer\">\r\n        <a href=\"/#/login\"><img data-bind=\"attr:{src:sessionStorage.getItem('headerLogo')?sessionStorage.getItem('headerLogo'):'/public/images/logo_3.0.png'}\"/></a>\r\n        <span class=\"split\">| </span>\r\n        <a href=\"/#/login\"><img src=\"/public/images/headerLoginOption.png\"/></a>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/common/loginHeader.html
// module id = 186
// module chunks = 0